/*
 * Copyright 2026 North Carolina State University
 */

import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/signin" replace />;
  }

  // Signed in with a temporary password from "Forgot password?": nothing else
  // until a new password is saved. Otherwise it's easy to click away, and the
  // temporary password expires a day later, locking them out.
  if (user.must_change_password && location.pathname !== '/profile') {
    return <Navigate to="/profile" replace state={{ mustChangePassword: true }} />;
  }

  if (adminOnly && !user.institution_roles?.some(r => r.role === 'Admin')) {
    return <Navigate to="/" replace />;
  }

  return React.cloneElement(children, { user });
};

export default ProtectedRoute;